import './NavLink.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

class NavLink extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    clickHandler: PropTypes.func,
    shouldRefresh: PropTypes.bool,
    stringID: PropTypes.string,
    text: PropTypes.string,
    to: PropTypes.string.isRequired,
  }

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  static defaultProps = {
    className: '',
    clickHandler: () => { },
    shouldRefresh: false,
    text: '',
  }

  constructor(props) {
    super(props);
    this.isActive = this.isActive.bind(this);
    this.getClassName = this.getClassName.bind(this);
    this.renderLink = this.renderLink.bind(this);
    this.renderAnchor = this.renderAnchor.bind(this);
  }

  getClassName() {
    const { className } = this.props;
    return `${className} aa-nav-link ${this.isActive() ? 'active' : ''}`;
  }

  isActive() {
    const { to } = this.props;
    const currentPath = window.location.pathname;
    const regex = new RegExp(`^${to}.*`);
    return currentPath.match(regex);
  }

  renderLink() {
    const {
      clickHandler,
      stringID,
      text,
      to,
    } = this.props;
    const { getString } = this.context;

    return (
      <Link className={this.getClassName()} to={to} onClick={clickHandler}>
        <span>{stringID ? getString(stringID) : text}</span>
      </Link>
    );
  }

  renderAnchor() {
    const {
      clickHandler,
      stringID,
      to,
    } = this.props;
    const { getString } = this.context;

    return (
      <a className={this.getClassName()} href={to} onClick={clickHandler}>
        <span>{getString(stringID)}</span>
      </a>
    );
  }

  render() {
    const { shouldRefresh } = this.props;
    return shouldRefresh ? this.renderAnchor() : this.renderLink();
  }
}

export default NavLink;
